import { FC } from 'react';

export const Resume: FC = () => {
  return (
    <div>
      <h3 className='page-title white-text'>Resume</h3>
      <div className='container'>
        <p>
          <a target='_blank' rel='noreferrer' href='/Resume_Siniakou_Alex.pdf'>
            <i className='fa fa-file-pdf fa-fw fa-2x grey-text text-darken-2'></i>
          </a>
          <a target='_blank' rel='noreferrer' href='/Resume_Siniakou_Alex.pdf'>
            Resume_Siniakou_Alex.pdf
          </a>
        </p>
        <p>
          <a target='_blank' rel='noreferrer' href='/Resume_Siniakou_Alex.doc'>
            <i className='fa fa-file-text fa-fw fa-2x grey-text text-darken-2'></i>
          </a>
          <a target='_blank' rel='noreferrer' href='/Resume_Siniakou_Alex.doc'>
            Resume_Siniakou_Alex.doc
          </a>
        </p>
      </div>
    </div>
  );
};
